import {
  ButtonDispenseColdStatesInterface,
  ButtonDispenseHotStatesInterface,
  ButtonDispenseMixStatesInterface,
  ButtonHotwaterStatesInterface,
  ButtonPitcherStatesInterface,
  ButtonSettingsStatesInterface,
  SimulatorEntryInterface,
  SimulatorPagesInterface
} from '../../interfaces/simulator-entry';

export class EntryPageFL {
  static initial(simulatorEntry: SimulatorEntryInterface) {
    simulatorEntry.page = SimulatorPagesInterface.FL;
    simulatorEntry.display.data = 'FL';
    simulatorEntry.buttons =  {
      dispenseCold: {active: false, state: ButtonDispenseColdStatesInterface.OFF},
      dispenseMix: {active: false, state: ButtonDispenseMixStatesInterface.OFF},
      dispenseHot: {active: false, state: ButtonDispenseHotStatesInterface.FLASHING},
      pitcher: {active: false, state: ButtonPitcherStatesInterface.OFF},
      settings: {active: false, state: ButtonSettingsStatesInterface.ACTIVE},
      hotWater: {active: false, state: ButtonHotwaterStatesInterface.OFF},
    }
  }

  static clickButtonSettings(simulatorEntry: SimulatorEntryInterface) {
    if (simulatorEntry.display.data !== 'FL') {
      if (simulatorEntry.display.data === 'ON') {
        simulatorEntry.settings.sound = true;
      } else {
        simulatorEntry.settings.sound = false;
      }
      return true;
    } else {
      return false;
    }
  }
}
